(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var accordions = document.querySelectorAll('.nomad-footer-accordion');

  function syncAccordions() {
    accordions.forEach(function (el) {
      if (MOBILE.matches) {
        if (!el.dataset.nomadMobileInit) {
          el.removeAttribute('open');
          el.dataset.nomadMobileInit = '1';
        }
      } else {
        el.setAttribute('open', '');
        delete el.dataset.nomadMobileInit;
      }
    });
  }

  if (accordions.length) {
    syncAccordions();
    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', syncAccordions);
    } else {
      MOBILE.addListener(syncAccordions);
    }
  }

  function setupFooterCountrySelector() {
    var extras = document.querySelector('.nomad-newsletter-extras');
    if (!extras) return;

    var form = extras.querySelector('localization-form');
    if (!form) return;

    var disclosure = form.querySelector('.disclosure');
    var btn = form.querySelector('button.localization-form__select');
    var panel = form.querySelector('.disclosure__list-wrapper');
    var overlay = form.querySelector('.country-selector__overlay');
    var closeBtn = form.querySelector('.country-selector__close-button');
    if (!btn || !panel || !disclosure) return;

    var panelAnchor = { parent: panel.parentNode, next: panel.nextSibling };
    var overlayAnchor = overlay
      ? { parent: overlay.parentNode, next: overlay.nextSibling }
      : null;

    panel.classList.add('nomad-country-sheet');
    if (overlay) {
      overlay.classList.add('nomad-country-overlay');
    }

    function isOpen() {
      return btn.getAttribute('aria-expanded') === 'true';
    }

    function mountSheetToBody() {
      if (!MOBILE.matches) return;
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }
      if (panel.parentNode !== document.body) {
        document.body.appendChild(panel);
      }
    }

    function restoreSheetDom() {
      if (overlay && overlayAnchor && overlay.parentNode === document.body) {
        if (overlayAnchor.next) {
          overlayAnchor.parent.insertBefore(overlay, overlayAnchor.next);
        } else {
          overlayAnchor.parent.appendChild(overlay);
        }
      }
      if (panel.parentNode === document.body) {
        if (panelAnchor.next) {
          panelAnchor.parent.insertBefore(panel, panelAnchor.next);
        } else {
          panelAnchor.parent.appendChild(panel);
        }
      }
    }

    function hideCountryPanel() {
      btn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
      disclosure.classList.remove('nomad-country-open');
      document.body.classList.remove('overflow-hidden-mobile', 'nomad-footer-country-open');

      var search = form.querySelector('input[name="country_filter"]');
      if (search) {
        search.value = '';
        search.blur();
      }

      restoreSheetDom();

      var drawer = document.querySelector('.menu-drawer');
      if (drawer) {
        drawer.classList.remove('country-selector-open');
      }
    }

    function showCountryPanel() {
      mountSheetToBody();
      btn.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      disclosure.classList.add('nomad-country-open');
      document.body.classList.add('overflow-hidden-mobile', 'nomad-footer-country-open');

      var drawer = document.querySelector('.menu-drawer');
      if (drawer) {
        drawer.classList.add('country-selector-open');
      }
    }

    function bindClose(target) {
      if (!target) return;
      target.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          if (isOpen()) {
            hideCountryPanel();
          }
        },
        true,
      );
    }

    bindClose(overlay);
    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          hideCountryPanel();
        },
        true,
      );
    }

    btn.addEventListener(
      'click',
      function (e) {
        if (!MOBILE.matches) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        if (isOpen()) {
          hideCountryPanel();
        } else {
          showCountryPanel();
        }
      },
      true,
    );

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      if (!extras.contains(form) && panel.parentNode !== document.body) return;
      hideCountryPanel();
      btn.focus();
    });

    document.addEventListener('click', function (e) {
      if (MOBILE.matches || !isOpen()) return;
      if (form.contains(e.target)) return;
      hideCountryPanel();
    });

    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', function () {
        if (!MOBILE.matches && isOpen()) {
          hideCountryPanel();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFooterCountrySelector);
  } else {
    setupFooterCountrySelector();
  }

  function setupNewsletterLanguagePicker() {
    var picker = document.getElementById('NewsletterLangPicker');
    var form = document.getElementById('ContactFooter');
    var tagsInput = document.getElementById('NewsletterContactTags');
    if (!picker || !form || !tagsInput) return;

    var buttons = picker.querySelectorAll('.nomad-newsletter-lang__btn');
    var currentLang = picker.getAttribute('data-default-lang') || 'es';

    function setLang(lang) {
      currentLang = lang === 'en' ? 'en' : 'es';
      tagsInput.value = 'newsletter, lang-' + currentLang;
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-lang') === currentLang;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLang(btn.getAttribute('data-lang') || 'es');
      });
    });

    form.addEventListener('submit', function () {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email) return;

      if (window._learnq) {
        window._learnq.push([
          'identify',
          {
            $email: email,
            language_preference: currentLang,
          },
        ]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupNewsletterLanguagePicker);
  } else {
    setupNewsletterLanguagePicker();
  }
})();
